<app-page-stepper
    [verticalSteps]="false"
    [submitVisible]="false"
    (stepChange)="onStepChange($event)"
    (tryNext)="onTryNext()">
    <app-stepper [canContinue]="canContinue()">
        <ng-template #title>
            {{ "lineSetter.toolRequest.pages.groupSubtitle" | translate }}
        </ng-template>
        <ng-template #content
                     let-step="step">
            <div class="ls-tool-request">
                <h5> {{ "lineSetter.toolRequest.pages.selectLineAndPartNumber" | translate }}</h5>
                <div class="ls-request-main-data">
                    <div class="request-input-container">
                        <label [ngClass]="{'error': !selectedLine && firstNextTried}" for="manufacturing-line">
                            {{ "lineSetter.toolRequest.stepper.manufacturingLine" | translate }}
                        </label>
                        <app-dropdown-autocomplete id="manufacturing-line"
                                                   [items]="lines"
                                                   valueField="id"
                                                   displayField="name"
                                                   [formControl]="toolRequestForm.controls['line']"
                                                   [emptyText]="'lineSetter.toolRequest.pages.searchManufacturingLine' | translate"
                                                   (selectItem)="onLineSelected($event)">
                        </app-dropdown-autocomplete>
                    </div>
                    <div class="request-input-container"
                         [ngClass]="{'disabled': !selectedLine || partNumbers.length === 0}">
                        <label [ngClass]="{'error': !selectedPartNumber && firstNextTried}" for="part-number">
                            {{ "lineSetter.toolRequest.pages.groupPartNumber" | translate }}
                        </label>
                        <app-dropdown-autocomplete id="part-number"
                                                   [items]="partNumbers"
                                                   [formControl]="toolRequestForm.controls['partNumber']"
                                                   valueField="id"
                                                   displayField="name"
                                                   [emptyText]="'lineSetter.toolRequest.pages.searchPartNumber' | translate"
                                                   (selectItem)="onPartNumberSelected($event)">
                        </app-dropdown-autocomplete>
                    </div>
                    <div class="request-input-container" *ngIf="selectedLine && selectedLine.isSPI"
                         [ngClass]="{'disabled': insertionCycles.length === 0}">
                        <label [ngClass]="{'error': !selectedInsertionCycle && firstNextTried}" for="insertion-cycles">
                            {{ "lineSetter.toolRequest.stepper.insertionCycle" | translate }}
                        </label>
                        <app-dropdown-autocomplete id="insertion-cycles"
                                                   [items]="insertionCycles"
                                                   [formControl]="toolRequestForm.controls['insertionCycle']"
                                                   valueField="id"
                                                   displayField="name"
                                                   [emptyText]="'lineSetter.toolRequest.pages.searchInsertionCycle' | translate"
                                                   (selectItem)="onInsertionCycleSelect($event)">
                        </app-dropdown-autocomplete>
                    </div>
                </div>
            </div>

        </ng-template>
    </app-stepper>
    <app-stepper [canContinue]="selectedTools.length > 0">
        <ng-template #title>
            {{ "lineSetter.toolRequest.stepper.selectTools" | translate }}
        </ng-template>
        <ng-template #content
                     let-step="step">
            <div class="tool-select-step">
                <div class="header">
                    <h2>{{ 'lineSetter.toolRequest.table.title' | translate }}</h2>
                    <app-display-label
                        labelClass="compact"
                        label="{{'lineSetter.toolRequest.stepper.manufacturingLine' | translate}}"
                        [value]="selectedLine?.name">
                    </app-display-label>
                    <app-display-label
                        labelClass="compact"
                        label="{{'lineSetter.toolRequest.stepper.partNumber' | translate}}"
                        [value]="selectedPartNumber?.name">
                    </app-display-label>
                    <app-display-label
                        labelClass="compact"
                        label="{{'lineSetter.toolRequest.stepper.insertionCycle' | translate}}"
                        [value]="selectedInsertionCycle?.name">
                    </app-display-label>
                </div>
                <app-tool-request-table class="body"
                                        [toolsGrouped]="toolsGrouped"
                                        [selectedTools]="selectedTools"
                                        [tableConfig]="tableConfig"
                                        [showGroupers]="false"
                                        [showGroupFilters]="false"
                                        [isFilterExpanded]="false"
                                        [isLoading]="isLoadingTools"
                                        (sortChange)="onSortChange($event)"
                                        (filterChange)="onFilterChange($event)"
                                        (groupChange)="onGroupChange($event)"
                                        (pageChange)="onPageChange($event)"
                                        (onToolClicked)="onToolClicked($event)">
                </app-tool-request-table>
            </div>
        </ng-template>
    </app-stepper>
    <app-stepper>
        <ng-template #title>Confirm</ng-template>
        <ng-template #content>
            <div class="tool-confirm-step">
                <div class="header">
                    <h2>{{ 'lineSetter.toolRequest.table.title' | translate }}</h2>
                    <app-display-label
                        labelClass="compact"
                        label="{{'lineSetter.toolRequest.stepper.manufacturingLine' | translate}}"
                        [value]="selectedLine?.name">
                    </app-display-label>
                    <app-display-label
                        labelClass="compact"
                        label="{{'lineSetter.toolRequest.stepper.partNumber' | translate}}"
                        [value]="selectedPartNumber?.name">
                    </app-display-label>
                    <app-display-label
                        labelClass="compact"
                        label="{{'lineSetter.toolRequest.stepper.insertionCycle' | translate}}"
                        [value]="selectedInsertionCycle?.name">
                    </app-display-label>
                </div>
                <div class="body">
                    <div class="row tools-to-order" *ngIf="currentStep === 3">
                        <ng-container *ngIf="!isLoadingTools">
                            <div class="tool-at-line">
                                <app-tool-scan-tree *ngIf="toolsToSwitch.length > 0"
                                                    [isMaterial]="false"
                                                    labelText="{{'lineSetter.toolRequest.pages.scanTreeToolAtline' | translate}}"
                                                    [items]="toolsToSwitch">
                                </app-tool-scan-tree>
                            </div>
                            <app-tool-scan-tree *ngIf="toolsFromAtom.length > 0"
                                                [isMaterial]="false"
                                                labelText="{{'lineSetter.toolRequest.pages.scanTreeLabel' | translate}}"
                                                [items]="toolsFromAtom">
                            </app-tool-scan-tree>
                        </ng-container>
                        <app-loading-spinner *ngIf="isLoadingTools"></app-loading-spinner>
                    </div>
                </div>
                <div class="footer">
                    <div *ngIf="toolsToSwitch.length > 0" class="line-setter-consent">
                        <app-input-switch [(ngModel)]="hasGiveConsent"></app-input-switch>
                        {{ 'lineSetter.toolRequest.messages.consent' | translate }}
                    </div>
                    <div class="buttons-container-tool-request">
                        <app-icon-button
                            class="left"
                            text="{{ 'lineSetter.toolRequest.pages.buttonOrder' | translate }}"
                            [responsive]="true"
                            [disabled]="!hasGiveConsent"
                            (click)="onOrder(false)">
                        </app-icon-button>
                        <app-icon-button
                            class="right"
                            variant="fa-exclamation-circle"
                            text="{{ 'lineSetter.toolRequest.pages.buttonOrderPriority' | translate }}"
                            [responsive]="true"
                            [disabled]="!hasGiveConsent"
                            (click)="onOrder(true)">
                        </app-icon-button>
                    </div>
                </div>
            </div>
        </ng-template>
    </app-stepper>
</app-page-stepper>
<app-confirmation-modal (confirmEvent)="onConfirmOrder($event)"
                        #successModal
                        title="{{'lineSetter.toolRequest.pages.popupTitle' | translate}}"
                        question="{{'lineSetter.toolRequest.pages.popupQuestion' | translate}}"
                        message="{{'lineSetter.toolRequest.pages.popupMessage' | translate}}"
                        displayReasonLabel="{{'lineSetter.toolRequest.messages.priorityMessageLabel' | translate}}"
                        displayReasonPlaceholder="{{'lineSetter.toolRequest.messages.priorityMessagePlaceholder' | translate}}"
                        [isConfirmationInProgress]="isConfirmationInProgress"
                        [confirmOnlyMode]="!orderWithPriority"
                        [confirmWithReason]="orderWithPriority">
</app-confirmation-modal>
<app-confirmation-modal #errorModal
                        title="{{'lineSetter.toolRequest.pages.popupError' | translate }}"
                        [message]="confirmationPopupMessage"
                        [confirmOnlyMode]="true"
                        [isError]="isError"
                        [showConfirmButton]="false ">
</app-confirmation-modal>
<app-logout-modal
    title="{{ 'lineSetter.toolRequest.pages.logoutModal.title' | translate }}"
    infoMessage="{{ 'lineSetter.toolRequest.pages.logoutModal.infoMessage' | translate }}"
    [timer]="badgeLogoutCountdownSeconds">
</app-logout-modal>
